import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, unref as _unref, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "align-middle inline-block w-full" }
const _hoisted_2 = {
  key: 0,
  class: "flex md:flex-row flex-col md:items-center md:justify-between p-4 border-b border-neutral-100"
}
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = {
  type: "submit",
  class: "border-0 mr-3"
}
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = { class: "bg-primary-100" }
const _hoisted_7 = ["colspan", "rowspan", "width"]
const _hoisted_8 = ["width"]
const _hoisted_9 = { class: "bg-white divide-y divide-gray-200 text-sm text-gray-500" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = ["colspan"]
const _hoisted_12 = { class: "text-sm text-gray-400 py-4" }

import { ref } from "vue";
import { ChevronUpDownIcon } from "@heroicons/vue/24/outline";
import SearchTwoIcon from "@/components/icons/searchTwoIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DetailTable',
  props: {
	modelValue: {
		default: null,
		required: true,
	},
	headers: {
		default: null,
		type: Object,
	},
	searchPlaceholder: {
		default: null,
		type: String,
	},
	parentTableClass: {
		default: 'overflow-auto max-w-[calc(100vw-34px)]',
		type: String,
	},
	tableClass: {
		default: null,
		type: String,
	},
	dataTableClass: {
		default: null,
		type: String,
	},

	haveSort: {
		default: false,
		type: Boolean,
	},
	hasSearch: {
		default: false,
		type: Boolean,
	},

	/* Text for empty list */
	emptyText: {
		default: "No data to display.",
		type: String,
	},

	/* Hide action column */
	noAction: {
		default: false,
		type: Boolean,
	},

	/* Action header text */
	actionText: {
		default: "Actions",
		type: String,
	},

	count: {
		default: 0,
		type: Number,
	},
	search: {
		type: String,
		default: null,
	},
},
  setup(__props) {

const props = __props;

const searchText = ref(props.search);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["frm-table border rounded-lg border-neutral-100", [__props.dataTableClass]])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (__props.hasSearch)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("button", _hoisted_4, [
                _createVNode(SearchTwoIcon, { class: "w-5 h-5 object-contain grayscale brightness-[0.3]" })
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                name: "search",
                id: "search",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchText).value = $event)),
                onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:searchText', $event.target.value))),
                placeholder: __props.searchPlaceholder,
                class: "p-0 text-neutral-600 placeholder:font-medium placeholder-neutral-400 border-0 focus:ring-0 focus:outline-none min-w-[300px]"
              }, null, 40, _hoisted_5), [
                [_vModelText, searchText.value]
              ])
            ]),
            _renderSlot(_ctx.$slots, "topContent")
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass([__props.parentTableClass, ""])
      }, [
        _createElementVNode("table", {
          class: _normalizeClass(["min-w-full divide-y border-none divide-gray-200", [__props.tableClass]])
        }, [
          _renderSlot(_ctx.$slots, "header", {}, () => [
            _createElementVNode("thead", _hoisted_6, [
              _createElementVNode("tr", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.headers, (header, index) => {
                  return (_openBlock(), _createElementBlock("th", {
                    key: `th-${index}`,
                    colspan: header.colspan,
                    rowspan: header.rowspan,
                    class: "px-6 py-6 text-left text-xs text-neutral-900 font-semibold whitespace-nowrap th-parent",
                    width: header.width
                  }, [
                    _createElementVNode("span", null, _toDisplayString(header.text), 1),
                    (header.haveSort)
                      ? (_openBlock(), _createBlock(_unref(ChevronUpDownIcon), {
                          key: 0,
                          class: "w-5 h-5 text-neutral-900 cursor-pointer inline-block ml-2"
                        }))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_7))
                }), 128))
              ]),
              _createElementVNode("tr", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.headers, (header, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, null, [
                    (header.subheaders)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(header.subheaders, (subheader, subIndex) => {
                          return (_openBlock(), _createElementBlock("th", {
                            key: `subth-${index}-${subIndex}`,
                            class: "px-6 py-6 text-left text-xs text-neutral-900 font-semibold whitespace-nowrap th-parent",
                            width: header.width
                          }, [
                            _createElementVNode("span", null, _toDisplayString(subheader), 1)
                          ], 8, _hoisted_8))
                        }), 128))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 256))
              ])
            ])
          ]),
          _createElementVNode("tbody", _hoisted_9, [
            (__props.count > 0)
              ? _renderSlot(_ctx.$slots, "body", { key: 0 })
              : (_openBlock(), _createElementBlock("tr", _hoisted_10, [
                  _createElementVNode("td", {
                    class: "whitespace-nowrap text-center",
                    colspan: __props.headers.length + (!__props.noAction ? 1 : 0)
                  }, [
                    _createElementVNode("div", _hoisted_12, _toDisplayString(__props.emptyText), 1)
                  ], 8, _hoisted_11)
                ]))
          ])
        ], 2)
      ], 2),
      _renderSlot(_ctx.$slots, "tfoot")
    ])
  ], 2))
}
}

})